import { Box, Typography, List, ListItem, ListItemText, Chip } from "@mui/material";
import Header from "../../../../components/Header";
import useAuth from "../../../../auth/useAuth";
import { useFetchGET } from "../../../../state/FetchHelpers";
import { automaticRoutesListRoute } from "../../../../config";
import Loading from "../../../global/Loading";
import FatalError from "../../../global/FatalError";

const MiRutaAutomatica = () => {
  const auth = useAuth();
  const token = auth.globals.token;

  const { data: routesResponse, loading, error } = useFetchGET(automaticRoutesListRoute("aprobada"), token, []);

  if (loading) return <Loading />;
  if (error) return <FatalError />;

  const routesListData = Array.isArray(routesResponse?.routes) ? routesResponse.routes : [];
  const myRoutes = routesListData.filter((route) => route.assigned_driver_id === auth.globals.id);

  return (
    <Box m="20px" marginBottom="64px">
      <Header title="Mi Ruta" subtitle="Paradas asignadas para hoy" />

      {myRoutes.length === 0 ? (
        <Typography align="center" color="text.secondary" mt={4}>
          No tienes rutas asignadas.
        </Typography>
      ) : (
        myRoutes.map((route) => {
          const orderedStops = [...(route.orders || [])].sort(
            (a, b) => (a.visit_order ?? 0) - (b.visit_order ?? 0)
          );
          return (
            <Box key={route.id} mb={4}>
              <Typography variant="h6" mb={1}>
                Ruta #{route.id} · {route.base_origin}
              </Typography>
              <List>
                {orderedStops.map((order) => (
                  <ListItem key={order.box_id} divider>
                    <ListItemText
                      primary={
                        <Box display="flex" alignItems="center" gap={1}>
                          <Chip label={`#${order.visit_order ?? "-"}`} size="small" color="secondary" />
                          <Typography fontWeight="bold">{order.senders_name}</Typography>
                        </Box>
                      }
                      secondary={`${order.senders_address} · ${order.senders_phone}`}
                    />
                  </ListItem>
                ))}
              </List>
            </Box>
          );
        })
      )}
    </Box>
  );
};

export default MiRutaAutomatica;
